export const SUB_CUSTOMER_FIELDS = {
  ID: 'id',
  DOCUMENT_ID: 'documentId',
  NAME: 'name',
  PHONE: 'phone',
  CODE: 'code',
  CUSTOMER_TYPE: 'customerType',
} as const

/** `placeholder` = real customer unknown at order time; replaced on the order after delivery */
export const SUB_CUSTOMER_TYPE = {
  REGULAR: 'regular',
  PLACEHOLDER: 'placeholder',
} as const

const K = 'subCustomers'

export const T_KEYS = {
  SUB_CUSTOMERS: {
    TITLE: `${K}.title`,
    SUBTITLE: `${K}.subtitle`,
    ADD: `${K}.addCustomer`,
    EDIT: `${K}.editCustomer`,
    CODE: `${K}.customerCode`,
    NAME: `${K}.customerName`,
    PHONE: `${K}.customerPhone`,
    TYPE: `${K}.customerType`,
    TYPE_ALL: `${K}.typeAll`,
    TYPE_REGULAR: `${K}.typeRegular`,
    TYPE_PLACEHOLDER: `${K}.typePlaceholder`,
    MAIN_CUSTOMER: `${K}.mainCustomer`,
    TOTAL: `${K}.total`,
    SEARCH_PLACEHOLDER: `${K}.searchPlaceholder`,
    NO_RESULTS: `${K}.noCustomersFound`,
    NO_RESULTS_HINT: `${K}.noCustomersFoundHint`,
    NAME_PLACEHOLDER: `${K}.namePlaceholder`,
    PHONE_PLACEHOLDER: `${K}.phonePlaceholder`,
    SAVE_SUCCESS: `${K}.saveSuccess`,
    SAVE_ERROR: `${K}.saveError`,
    LOAD_ERROR: `${K}.loadError`,
    SEARCHING: `${K}.searching`,
    REMOVE: `${K}.remove`,
    SELECT_TENANT_TO_ADD: `${K}.selectTenantToAdd`,
  },
  COMMON: { CANCEL: 'common.cancel', SAVE: 'common.save', RETRY: 'common.retry' },
} as const

export const SUB_CUSTOMER_PAGE_SIZES = [10, 20, 50, 100]
export const SUB_CUSTOMER_DEFAULT_PAGE_SIZE = 20
export const SUB_CUSTOMER_SEARCH_DEBOUNCE_MS = 300
/** Results shown in the multi-select picker per search. */
export const SUB_CUSTOMER_PICKER_PAGE_SIZE = 20

/** Type filter choices; `null` = every type. */
export const SUB_CUSTOMER_TYPE_FILTERS = [
  { value: null, labelKey: T_KEYS.SUB_CUSTOMERS.TYPE_ALL },
  { value: SUB_CUSTOMER_TYPE.REGULAR, labelKey: T_KEYS.SUB_CUSTOMERS.TYPE_REGULAR },
  { value: SUB_CUSTOMER_TYPE.PLACEHOLDER, labelKey: T_KEYS.SUB_CUSTOMERS.TYPE_PLACEHOLDER },
] as const

export const API_ENDPOINTS = {
  LIST: '/api/sub-customers',
  DETAIL: (id: string) => `/api/sub-customers/${id}`,
} as const
